import React, {useState, useEffect} from "react";
import Menu from "../../../../../components/layout/menu/index";
import FilterInput from "../../../../../components/filters/filterInput";
import TablePrevGuestUser from "../../../../../components/tables/users/excelPreview/guestUser";
import SaveButton from "../../../../../components/forms/saveButton";
import CancelButton from "../../../../../components/forms/cancelButton";
import { useLocation } from "react-router-dom";
import { softDeletePreUsers } from "../../../../../client/users";
import { useNavigate } from 'react-router-dom';
import ModalSuccess from "../../../../../components/shared/modals/modalSuccess";
import ModalAlertWarning from "../../../../../components/shared/modals/modalAlertWarning";


export default function PreviewGuestUser() {
    const location = useLocation();
    const [isMenuOpen, setIsMenuOpen] = useState(false);
    const toggleMenu = () => setIsMenuOpen(!isMenuOpen);
    const navigate = useNavigate();
    
    const [currentPage, setCurrentPage] = useState(1);
    const [searchTerm, setSearchTerm] = useState('');
    const recordsPerPage = 9;
    const [excelData, setExcelData] = useState([]);
    const [filteredData, setFilteredData] = useState([]);
    const [paginatedData, setPaginatedData] = useState([]);
    const [selectedRole, setSelectedRole] = useState(null);

    const [deletedUserIds, setDeletedUserIds] = useState ([]);
    const [isProcessing, setIsProcessing] = useState(false);

    const [showModalSuccess, setShowModalSuccess] = useState(false);
    const [successMessage, setSuccessMessage] = useState('');
    const [showModalAlertWarning, setShowModalAlertWarning] = useState(false);
    const [errorMessage, setErrorMessage] = useState('');


    useEffect(() => {
        if (location.state?.excelData) {
            setExcelData(location.state.excelData);
            setFilteredData(location.state.excelData);
            setSelectedRole(location.state.selectedRole);
        }
    }, [location]);

  useEffect(() => {
    if (searchTerm === '') {
        setFilteredData(excelData);
    } else {
        const lowercasedSearch = searchTerm.toLowerCase();
        const filtered = excelData.filter(item => {
            if (!item) return false;
            return Object.values(item).some(val => 
                val !== null && val !== undefined && 
                String(val).toLowerCase().includes(lowercasedSearch)
            );
        });
        setFilteredData(filtered);
    }
    setCurrentPage(1);
}, [searchTerm, excelData]);


useEffect(() => {
  const startIndex = (currentPage - 1) * recordsPerPage;
  const endIndex = startIndex + recordsPerPage;
  setPaginatedData(filteredData.slice(startIndex, endIndex));
}, [filteredData, currentPage, recordsPerPage]);

const checkIfLastUserAndNavigate = (updatedData) => {
  if (updatedData.length === 0) {
    setTimeout(() => {
      navigate(-1);
    }, 500); 
  }
};

const handleDelete = (userId) => {
    const updatedData = excelData.filter(user => user.id !== userId);
    setExcelData(updatedData);
    
    setDeletedUserIds(prev => [...prev, userId]);
    checkIfLastUserAndNavigate(updatedData);
};

const handleSearchChange = (e) => {
  setSearchTerm(e.target.value);
  setCurrentPage(1); 
};

const handleSave = async () => {
  if (deletedUserIds.length === 0) {
      setSuccessMessage('Se guardaron los cambios con éxito.');
      setShowModalSuccess(true);
      return;
  }

  setIsProcessing(true);
  
  try {
      const response = await softDeletePreUsers(deletedUserIds);
      setSuccessMessage('Se guardaron los cambios con éxito.');
      setShowModalSuccess(true);
  } catch (error) {
      console.error('Error al eliminar usuarios:', error);
      setErrorMessage(error);
      setShowModalAlertWarning(true);
  } finally {
      setIsProcessing(false);
  }
};


const handleCancel = async () => {
  const allUserIds = excelData.map(user => user.id);
  const userIdsToDelete = [...allUserIds, ...deletedUserIds];
  
  setIsProcessing(true);
  
  try {
      const response = await softDeletePreUsers(userIdsToDelete);
      navigate(-1);
  } catch (error) {
      console.error('Error al cancelar y eliminar usuarios:', error);
      setErrorMessage('Error al cancelar la operación');
      setShowModalAlertWarning(true);
  } finally {
      setIsProcessing(false);
  }
};

  const handleCloseSuccessModal = () => {
    setShowModalSuccess(false);
    navigate(-1); 
  };

  const handleCloseErrorModal = () => {
    setShowModalAlertWarning(false);
  };
      

  return (
    <div className="min-h-screen">
      <Menu isMenuOpen={isMenuOpen} toggleMenu={toggleMenu} className="transition-all duration-300" />
      <div className={`flex-1 pt-[67px] transition-all duration-300 bg-[#F7F8F9] w-full z-50 min-h-screen ${isMenuOpen ? "xl:pl-[20.7%] lg:pl-[23.7%] pl-0" : "pl-0"}`}>
        <div className="md:pt-8 pt-4 pb-10 px-[3%] min-h-screen">   
            <div className="flex flex-col gap-3">
              <h1 className="text-blue font-itcbold text-2xl md:text-[32px]">
                Previsualización Registro Usuario Invitado
              </h1>
      
              <div className="flex justify-start">
                <FilterInput
                title="Buscar"
                gray={true}
                value={searchTerm}
                onChange={handleSearchChange}
                />
              </div>
  
              <TablePrevGuestUser
                recordsPerPage={recordsPerPage}
                currentPage={currentPage}
                setCurrentPage={setCurrentPage}
                searchTerm={searchTerm}
                excelData={paginatedData}
                totalRecords={filteredData.length}
                onDeleteUser={handleDelete}
              />

                <div className="flex items-center justify-center pt-16">
                    <div className="flex w-full md:w-[65%] gap-7 items-center justify-center">
                        <SaveButton onClick={handleSave} disabled={isProcessing}/>
                        <CancelButton onClick={handleCancel} disabled={isProcessing}/>
                    </div>
                </div>
            </div>

        </div>
      </div>


      <ModalSuccess 
        showModalSuccess={showModalSuccess}
        closeModalSuccess={handleCloseSuccessModal}
        fill="green" 
        text={successMessage}
      />

      <ModalAlertWarning 
        showModalAlertWarning={showModalAlertWarning}
        closeModal={handleCloseErrorModal}
        error={errorMessage}
        accept={handleCloseErrorModal}
      />

    </div>
  );
}